import { Typography } from '@material-ui/core'
import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/core/styles'
import { list as listCategories } from 'api/library/categories'
import { create } from 'api/library/posts'
import CreateButton from 'components/library/post/CreateButton'
import PostForm from 'components/library/post/PostForm'
import { LoadingContext } from 'contexts/LoadingContext'
import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useToasts } from 'react-toast-notifications'

const useStyles = makeStyles(theme => ({
  container: {
    maxWidth: theme.breakpoints.width('lg'),
    margin: 'auto',
  },
  section: {
    display: 'grid',
    gridGap: theme.spacing(2),
    gridTemplateAreas: '"column-2" "column-1"',

    [theme.breakpoints.up('md')]: {
      gridGap: theme.spacing(4),
      gridTemplateAreas: '"column-1 column-2"',
      gridTemplateColumns: '8fr 4fr',
    },
  },
  column1: {
    gridArea: 'column-1',
  },
  column2: {
    gridArea: 'column-2',
  },
}))

function LibraryDistResellerPostCreate(props) {
  const { resellerId, resellerName } = useParams()
  const classes = useStyles()
  const { loading, setLoading } = useContext(LoadingContext)
  const { addToast } = useToasts()
  const [categories, setCategories] = useState({})
  const [tags, setTags] = useState({})
  const [values, setValues] = useState({
    name: '',
    content: '',
    image: {},
    featured: '',
    youtube_id: '',
    categories: [],
    tags: [],
    files: [],
  })
  const [errors, setErrors] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      const [catData, tagData] = await Promise.all([
        listCategories(1000, 1, resellerId),
        [],
      ])
      setCategories(catData)
      setTags(tagData)
      setLoading(false)
    }

    fetchData()
  }, [setLoading, resellerId])

  const handleChange = event => {
    const { name, value } = event.target
    setValues({ ...values, [name]: value })
  }

  const handleSave = async () => {
    setLoading(true)

    const data = new FormData()

    if (resellerId) {
      data.append('rid', resellerId)
    }

    data.append('name', values.name ?? '')
    data.append('content', values.content ?? '')
    data.append('image', values.image.hasOwnProperty('data') ? values.image.data : '')
    data.append('featured', values.featured ? values.featured : 0)
    data.append('youtube_id', values.youtube_id ?? '')

    values.categories.map(x => data.append('categories[]', x.id))
    values.tags.map(x => data.append('tags[]', x))
    values.files
      .filter(x => x.hasOwnProperty('file'))
      .map(x => data.append('files[]', x.file))
    values.files
      .filter(x => x.hasOwnProperty('file'))
      .map(x =>
        data.append(
          `new_file_display_types[]`,
          x.hasOwnProperty('display_type') ? x.display_type : 'large'
        )
      )
    values.files
      .filter(x => x.id)
      .map(x =>
        data.append(
          `file_display_types[${x.id}]`,
          x.hasOwnProperty('display_type') ? x.display_type : 'large'
        )
      )

    const res = await create(data)

    setLoading(false)

    if (res.success) {
      addToast('Saved Successfully', { appearance: 'success' })
      props.history.push('/resellers')
    } else {
      setErrors(res.errors)
    }
  }

  if (!categories.data) {
    return null
  }

  return (
    <Box className={classes.container}>
      <Typography variant='h3' gutterBottom>
        Create Post For {resellerName}
      </Typography>

      <PostForm
        post=''
        categories={categories}
        tags={tags}
        values={values}
        errors={errors}
        handleChange={handleChange}
      />

      <Box className={classes.section}>
        <Box className={classes.column1}>
          <CreateButton loading={loading} handleSave={handleSave} />
        </Box>
      </Box>
    </Box>
  )
}

export default LibraryDistResellerPostCreate
